import * as yup from 'yup'

export const addInvoiceSchema = yup.object({
    client: yup.object().required("Please select client!").nullable(),
    date: yup.date().required("Please select date!").nullable(),
    title: yup.string().required("Please enter title!"),
    itemsData: yup.array().min(1, "Atlease one item is required!").required()
})